<template>
  <div class="view-product-up-sell-new">
    <action-dispatcher
      v-if="$route.params.funnel"
      action="funnel/getDetails"
      :parameters="$route.params.funnel"
    >
      <up-sell-new :funnel="funnel" :product-id="$route.params.id" />
    </action-dispatcher>
    <up-sell-new v-else :product-id="$route.params.id" />
  </div>
</template>

<script>
import UpSellNew from "@/components/upsell/New.vue";
import { mapState } from "vuex";

export default {
  components: { UpSellNew },
  computed: {
    ...mapState("funnel", ["funnel"])
  }
};
</script>
